import type { RefObject } from "react";

const findScrollContainer = (element: HTMLElement | null) => {
  if (!element) {
    return undefined;
  }

  let parent = element.parentElement;
  while (parent) {
    const { overflow } = window.getComputedStyle(parent);
    if (overflow.split(" ").every((o) => o === "auto" || o === "scroll")) {
      return parent;
    }
    parent = parent.parentElement;
  }

  return document.documentElement;
};

const defaultGetTop = (
  el: HTMLElement,
  parent: HTMLElement,
  _defaultGetTop?: (el: HTMLElement, parent: HTMLElement) => number,
) => parent.scrollTop + el.getBoundingClientRect().y;

export const scrollToRef = (
  ref: RefObject<HTMLElement | null>,
  getTop: typeof defaultGetTop = defaultGetTop,
  behavior?: ScrollBehavior,
) => {
  const el = ref.current;
  if (!el) return;

  setTimeout(() => {
    if (!el) return;
    const parent = findScrollContainer(el);
    parent?.scrollTo?.({
      top: getTop(el, parent, defaultGetTop),
      behavior,
    });
  }, 50);
};

export const scrollToParentTop = (
  ref: RefObject<HTMLElement | null>,
  behavior?: ScrollBehavior,
) => {
  const el = ref.current;
  setTimeout(() => {
    if (!el) return;
    findScrollContainer(el)?.scrollTo({ top: 0, behavior });
  }, 50);
};
